import { render, staticRenderFns } from "./PaytableFeatures.vue?vue&type=template&id=b3672f8e&scoped=true&"
import script from "./PaytableFeatures.vue?vue&type=script&lang=ts&"
export * from "./PaytableFeatures.vue?vue&type=script&lang=ts&"
import style0 from "./PaytableFeatures.vue?vue&type=style&index=0&id=b3672f8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3672f8e",
  null
  
)

export default component.exports